/* Register FilePond plugins before 1r-theme.js creates instances */
if (typeof FilePond !== 'undefined') {
  FilePond.registerPlugin(
    FilePondPluginFileValidateType,
    FilePondPluginImageCrop,
    FilePondPluginImageResize,
    FilePondPluginImageTransform,
    FilePondPluginImagePreview
  );
}
